<template>
  <div :class="{'optimisation-job-sheet': true, 'active': active}" @click.prevent="$emit('click', $event)">
    <template v-if="!isAddSheetButton">
      <div class="title">{{sheet.stock.code}}</div>
      <div class="thumb">
        <img :src="sheet.thumbnailImageData">
      </div>
      <div class="info">{{sheet.height}} x {{sheet.width}}</div>
    </template>
    <template v-if="isAddSheetButton">
      <div class="title">&nbsp;</div>
      <div class="optimisation-job-sheet-add">
        <div class="add-sheet">ADD SHEET</div>
      </div>
      <div class="info">&nbsp;</div>
    </template>
  </div>
</template>


<style scoped>
.optimisation-job-sheet {
  width: 110px;
  height: 110px;
  display:inline-block;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;
}
.optimisation-job-sheet.active {
  background-color: #333333;
  border: 1px solid #000000;
  border-radius: 10px;
}
.optimisation-job-sheet > .title {
  font-size: 14px;
  color: #A0A0A0;
  font-weight: bold;
}
.optimisation-job-sheet.active > .title {
  color: #FFFFFF;
}
.optimisation-job-sheet > .thumb {
  background-color: #272727;
  width: 100%;
  height: 54px;
  overflow: hidden;
}
.optimisation-job-sheet > .thumb > img {
  height: 100%;
  margin: auto auto;
}
.optimisation-job-sheet > .info {
  font-size: 11px;
  color: #A0A0A0;
}
.optimisation-job-sheet.active > .info {
  color: #FFFFFF;
}
.optimisation-job-sheet-add {
  position: relative;
  color: #A0A0A0;
  border: 2px dashed #808080;
  width: 100%;
  height: 60px;
  overflow: hidden;
  border-radius: 15px;
  text-align: center;
  white-space: normal;
}
.optimisation-job-sheet:hover > .optimisation-job-sheet-add {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.optimisation-job-sheet-add > i {
  display: inline-block;
  font-size: 20px;  
  vertical-align: middle;
  line-height: 60px;
  margin-left: -5px;
  margin-top: -10px;
}
.optimisation-job-sheet-add > .add-sheet {
  position: absolute;
  font-size: 14px;  
  bottom: 8px;
  text-align: center;
  width: 100%;
}
</style>


<script>
export default {
  name: 'QueueOptimiserSheet',
  props: {
    sheet: Object,
    active: {
      type: Boolean,
      default: false
    },
    isAddSheetButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>